import useMediaQuery from './useMediaQuery'
import MediaQuery from './Component'
import Context from './Context'

export {
  MediaQuery as default,
  useMediaQuery,
  Context
}



// WEBPACK FOOTER //
// ./src/index.js